import { render, staticRenderFns } from "./AddNewDiscussion.vue?vue&type=template&id=023864fc&"
import script from "./AddNewDiscussion.vue?vue&type=script&lang=js&"
export * from "./AddNewDiscussion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports